module.exports = __webpack_public_path__ + "static/media/3-1.acbd9513.png";